import "../Stylesheet/About.css";
import image1 from "../Assets/Container.png";
import image2 from "../Assets/Container (1).png";
import image4 from "../Assets/Container (2).png";
import image5 from "../Assets/Container (3).png";
import image6 from "../Assets/Container (4).png";
import image7 from "../Assets/Container (5).png";
import { LuGraduationCap } from "react-icons/lu";
import { LuDownload } from "react-icons/lu";
import { GoTrophy } from "react-icons/go";
import { CiStar } from "react-icons/ci";
import { SlBadge } from "react-icons/sl";
import { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";
import { FaArrowUp } from "react-icons/fa";

export default function About() {

  const { t } = useContext(LanguageContext);
  const a = t.about;

  const [showArrow, setShowArrow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowArrow(true);
      } else {
        setShowArrow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const galleryImages = [image1, image2, image4, image5, image6, image7,];

  return (
    <>
      <div className="about-wrapper">

        {/* HEADER */}
        <div className="about-header">
          <h1>{a.title}</h1>
          <p>{a.intro}</p>
        </div>

        {/* EDUCATION */}
        <div className="about-section">
          <div className="section-title">
            <span className="edu"><LuGraduationCap /></span>
            <h2>{a.educationTitle}</h2>
          </div>

          <div className="education-card">
            <div className="education-left">
              <h3 className="edu-h3">{a.education.degree}</h3>
              <span className="edu-university">{a.education.university}</span>
              <p>{a.education.description}</p>

              <div className="edu-tags">
                {a.education.tags.map((tag, i) => (
                  <span key={i}>{tag}</span>
                ))}
              </div>

            </div>

            <div className="education-right">
              <span className="right-bg">{a.education.year}</span>
            </div>
          </div>
        </div>

        {/* LIFE & WORK */}
        <div className="about-section">
          <div className="section-title">
            <span className="about-star"><CiStar /> </span>
            <h2>{a.lifeWorkTitle}</h2>
          </div>

          <div className="gallery">
            {galleryImages.map((img, i) => (
              <div key={i} className="gallery-card">
                <img src={img} alt={`gallery-${i}`} />
              </div>
            ))}
          </div>


        </div>

        {/* ACHIEVEMENTS */}
        <div className="about-section">
          <div className="section-title">
            <span className="achi-trophy"><GoTrophy /></span>
            <h2>{a.achievementsTitle}</h2>
          </div>

          <div className="achievements">
            {a.achievements.map((item, i) => (
              <div className="achievement-card" key={i}>
                <div className={`achi-icon color${i + 1}`}>
                  {i === 0 && <GoTrophy />}
                  {i === 1 && <SlBadge />}
                  {i === 2 && <CiStar />}
                  {i === 3 && <LuGraduationCap />}
                </div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

        </div>

        {/* BUTTON */}
        <div className="about-footer">
          <button><LuDownload />{a.resumeBtn}</button>
        </div>

      </div>

      {showArrow && (
        <div className="scroll-top-arrow" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}

    </>
  );
}
